<template>
    <div v-if="contract">
        <form @submit.prevent="handleSubmit">
            <div class="section">
                <div class="card z-depth-0 grey lighten-4">
                    <div class="card-content review-heading">
                        <span class="card-title teal-text"><span class="chip">6/6</span> Review Client's
                            Details</span>
                        <p>Confirm the onboarding details before creating the client record.</p>
                    </div>

                    <div class="card-panel review-panel">
                        <div class="row">
                            <div class="col s12 m4">
                                <span class="review-label">Client</span>
                            </div>
                            <div class="col s10 m7">
                                <h6>{{ contract?.profile?.name }} <span>({{ contract?.profile?.abbr }})</span></h6>
                            </div>
                            <div class="col s2 m1">
                                <i class="material-icons review-check right">check_circle</i>
                            </div>
                        </div>
                        <div class="row review-detail-row">
                            <div class="col s12 m4"></div>
                            <div class="col s12 m8">{{ contract?.profile?.address }} <b>({{ contract?.profile?.state }})</b>
                            </div>
                        </div>
                        <div class="row review-detail-row">
                            <div class="col s12 m4"></div>
                            <div class="col s12 m8">
                                <span class="review-soft-pill">{{ contract?.profile?.email }}</span>
                                <span class="review-soft-pill">{{ contract?.profile?.phone }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="card-panel review-panel">
                        <div class="row">
                            <div class="col s12 m4">
                                <span class="review-label">{{ cat == "tpa" ? "TPA" : "Policy" }} Year</span>
                            </div>
                            <div class="col s10 m7 review-main-text">
                                {{ contract?.policy?.formatted?.withFullMonths }}
                            </div>
                            <div class="col s2 m1">
                                <i class="material-icons review-check right">{{
                                    contract.status == 0 ? "schedule" : "check_circle"
                                }}</i>
                            </div>
                        </div>
                    </div>

                    <div class="card-panel review-panel">
                        <div class="row">
                            <div class="col s12 m4"><span class="review-label">Settings</span></div>
                            <div class="col s10 m7 review-chip-line">
                                <span class="review-setting-pill">Family Size {{ contract?.settings?.[0]?.value }}</span>
                                <span class="review-setting-pill">Principal {{ contract?.settings?.[1]?.value }}yrs</span>
                                <span class="review-setting-pill">Dependant {{ contract?.settings?.[2]?.value }}yrs</span>
                            </div>
                            <div class="col s2 m1">
                                <i class="material-icons review-check right">check_circle</i>
                            </div>
                        </div>
                    </div>

                    <div class="card-panel review-panel" v-if="cat == 'tpa' && contract?.plans?.length">
                        <div class="row">
                            <div class="col s12 m4"><span class="review-label">Reference Plans</span></div>
                            <div class="col s10 m7 review-chip-line">
                                <span class="review-plan-pill">{{ contract.plans.length }} plan{{ contract.plans.length > 1 ? "s" : "" }} selected</span>
                            </div>
                            <div class="col s2 m1">
                                <i class="material-icons review-check right">check_circle</i>
                            </div>
                        </div>
                    </div>

                    <div class="card-panel review-panel">
                        <div class="row">
                            <div class="col s12 m4"><span class="review-label">Payment Installments</span></div>
                            <div class="col s10 m7 review-chip-line">
                                <span class="review-installment-pill" v-for="installment in contract.installments" :key="installment.id">
                                    {{ installment.formatted.shortMonthRange }}
                                </span>
                            </div>
                            <div class="col s2 m1">
                                <i class="material-icons review-check right">{{
                                    contract.status == 0 ? "schedule" : "check_circle"
                                }}</i>
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Sumbmitting -->
                <div class="progress" v-if="isSubmitting">
                    <div class="indeterminate"></div>
                </div>

                <div class="summary-action-row">
                    <a href="#" class="waves-effect waves-light btn-large black" :class="{
                        disabled:
                            isSubmitting
                    }" @click.prevent="handleBack()">
                        <i class="material-icons left">chevron_left</i> Back
                    </a>

                    <button class="waves-effect waves-light btn-large" :class="{
                        disabled:
                            !contract ||
                            !allModules?.length ||
                            !allSchemes?.length ||
                            isSubmitting
                    }">
                        <i class="material-icons white-text left">check_circle</i>{{ isSubmitting ?
                            "Creating..."
                            : "Create Client" }}
                    </button>
                </div>
            </div>
        </form>

    </div>

    <!-- Unloaded contract -->
    <div class="section" v-else>
        <div class="card-panel">
            <div class="row center">
                <div class="col s12"><span>Sorry, Contract isn't loading!</span></div>
            </div>
        </div>
    </div>

</template>

<script>
import { computed, onMounted, ref } from "vue";
import getItems from "@/composables/getItems";
import postItem from "@/composables/postItem";
import { addModules } from "@/composables/cache/modules";

export default {
    name: "ReviewOnboardComponent",
    emits: ["back", "next"],
    props: ["cat", "newClient"],
    setup(props, context) {
        const response = ref(null);
        const isSubmitting = ref(false);
        const allModules = ref([]);
        const allSchemes = ref([]);
        const error = ref(false);

        // Modules and Schemes
        onMounted(() => {
            // get modules
            allModules.value = addModules()
                .filter(x => x.type === "client")
                .map(item => item.to);

            // get schemes
            (async () => {
                const { res } = await getItems("scheme");

                if (res.value) {
                    allSchemes.value = res.value.data.filter(x => x.type === "p") // private schemes only
                        .map(item => item.id);
                } else {
                    error.value = "ERROR: Important data not loaded!";
                }

            })();
        });

        // on
        onMounted(() => {
            // load
            response.value = props.newClient;
            response.value.policy = getPolicyYearDates(response.value.status[0].value);
            response.value.installments = calculateInstallmentPeriods(response.value.status[0].value, 12 / response.value.status[1].value);
        });

        // policy period
        const getPolicyYearDates = (startDateStr) => {
            /**
             * Calculate exact policy year dates from start date (beginning to end of 12-month period)
             * @param {string} startDateStr - Start date in YYYYMMDD format
             * @returns {object} { policyStart, policyEnd, formatted }
             */

            const monthNames = {
                full: ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'],
                short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            };

            // Parse start date
            const year = parseInt(startDateStr.substring(0, 4));
            const month = parseInt(startDateStr.substring(4, 6)) - 1;
            const day = parseInt(startDateStr.substring(6, 8));
            const policyStart = new Date(year, month, day);

            // Calculate end date (12 months later minus 1 day)
            const policyEnd = new Date(policyStart);
            policyEnd.setFullYear(policyEnd.getFullYear() + 1);
            policyEnd.setDate(policyEnd.getDate() - 1);

            // Formatting helpers
            const formatDate = (date) => date.toISOString().split('T')[0];
            const getMonthName = (date, type) => monthNames[type][date.getMonth()];
            const formatDayMonth = (date) => `${date.getDate()} ${getMonthName(date, 'short')}`;

            return {
                policyStart: new Date(policyStart),
                policyEnd: new Date(policyEnd),
                formatted: {
                    // Basic formats
                    fullStart: formatDate(policyStart),
                    fullEnd: formatDate(policyEnd),
                    displayRange: `${formatDate(policyStart)} to ${formatDate(policyEnd)}`,

                    // Month names
                    startMonth: {
                        full: getMonthName(policyStart, 'full'),
                        short: getMonthName(policyStart, 'short')
                    },
                    endMonth: {
                        full: getMonthName(policyEnd, 'full'),
                        short: getMonthName(policyEnd, 'short')
                    },

                    // Enhanced displays
                    withFullMonths: `${getMonthName(policyStart, 'full')} ${policyStart.getDate()}, ${policyStart.getFullYear()} to ${getMonthName(policyEnd, 'full')} ${policyEnd.getDate()}, ${policyEnd.getFullYear()}`,
                    withShortMonths: `${formatDayMonth(policyStart)}, ${policyStart.getFullYear()} to ${formatDayMonth(policyEnd)}, ${policyEnd.getFullYear()}`,
                    yearRange: `${policyStart.getFullYear()}-${policyEnd.getFullYear()}`,
                    shortRange: `${getMonthName(policyStart, 'short')} ${policyStart.getFullYear()} - ${getMonthName(policyEnd, 'short')} ${policyEnd.getFullYear()}`
                },
                daysInPolicy: Math.floor((policyEnd - policyStart) / (1000 * 60 * 60 * 24)) + 1
            };
        }

        // installments
        const calculateInstallmentPeriods = (startDateStr, installmentsPerYear) => {
            /**
             * Calculate exactly 12-month installment periods from the given start date
             * with proper month name formatting
             */

            const monthNames = {
                full: ['January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'],
                short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            };

            // Validate input
            if (12 % installmentsPerYear !== 0) {
                throw new Error("Installments per year must divide 12 evenly (1, 2, 3, 4, 6, or 12)");
            }

            // Parse start date
            const year = parseInt(startDateStr.substring(0, 4));
            const month = parseInt(startDateStr.substring(4, 6)) - 1;
            const day = parseInt(startDateStr.substring(6, 8));
            const policyStart = new Date(year, month, day);

            // Calculate exactly 12 months later (same day)
            const policyEnd = new Date(policyStart);
            policyEnd.setFullYear(policyEnd.getFullYear() + 1);
            policyEnd.setDate(policyEnd.getDate() - 1); // Last day of 12-month period

            const monthsPerPeriod = 12 / installmentsPerYear;
            const periods = [];
            let currentStart = new Date(policyStart);

            for (let i = 1; i <= installmentsPerYear; i++) {
                const periodEnd = new Date(currentStart);

                if (i === installmentsPerYear) {
                    // Last period ends at policy end date
                    periodEnd.setTime(policyEnd.getTime());
                } else {
                    periodEnd.setMonth(periodEnd.getMonth() + monthsPerPeriod);
                    periodEnd.setDate(periodEnd.getDate() - 1); // Previous day
                }

                // Formatting functions
                const formatDate = (date) => date.toISOString().split('T')[0];
                const getMonthName = (date, type) => monthNames[type][date.getMonth()];
                const formatDayMonth = (date) =>
                    `${date.getDate()} ${getMonthName(date, 'short')}`;

                periods.push({
                    periodNumber: i,
                    startDate: new Date(currentStart),
                    endDate: new Date(periodEnd),
                    formatted: {
                        // Basic formats
                        fullStart: formatDate(currentStart),
                        fullEnd: formatDate(periodEnd),
                        displayRange: `${formatDate(currentStart)} to ${formatDate(periodEnd)}`,

                        // Month names
                        startMonth: {
                            full: getMonthName(currentStart, 'full'),
                            short: getMonthName(currentStart, 'short')
                        },
                        endMonth: {
                            full: getMonthName(periodEnd, 'full'),
                            short: getMonthName(periodEnd, 'short')
                        },

                        // Enhanced displays
                        withFullMonths: `${getMonthName(currentStart, 'full')} ${currentStart.getDate()}, ${currentStart.getFullYear()} to ${getMonthName(periodEnd, 'full')} ${periodEnd.getDate()}, ${periodEnd.getFullYear()}`,
                        withShortMonths: `${formatDayMonth(currentStart)}, ${currentStart.getFullYear()} to ${formatDayMonth(periodEnd)}, ${periodEnd.getFullYear()}`,
                        monthRange: `${getMonthName(currentStart, 'full')} - ${getMonthName(periodEnd, 'full')} ${periodEnd.getFullYear()}`,
                        shortMonthRange: `${getMonthName(currentStart, 'short')}-${getMonthName(periodEnd, 'short')} ${periodEnd.getFullYear()}`,
                    },
                    daysInPeriod: Math.floor((periodEnd - currentStart) / (1000 * 60 * 60 * 24)) + 1
                });

                // Next period starts the day after this one ends
                currentStart = new Date(periodEnd);
                currentStart.setDate(currentStart.getDate() + 1);
            }

            return periods;
        }

        // handle back
        const handleBack = () => {
            // emit new parameters
            context.emit("back", {
                id: "review",
                value: true,
            });
        }

        // handle back
        const handleSubmit = async () => {
            // perform submission
            // start
            isSubmitting.value = true;

            let newVal = { ...props.newClient, 
                schemes: allSchemes.value,
                modules: allModules.value,
             };

            // post item
            const { res, err } = await postItem("operator/client/add", newVal);
            if (res.value) {
                // emit new parameters
                context.emit("next", {
                    id: "review",
                    value: res.value.data,
                });
            } else {
                error.value = err.value;
            }

            // close
            isSubmitting.value = false;
        }

        // output pages
        const contract = computed(() => {
            if (!response.value) {
                return [];
            } else {
                return response.value;
            }
        });

        return {
            isSubmitting,
            handleSubmit,
            handleBack,
            allModules,
            allSchemes,
            error,
            contract,
        };
    },
};
</script>


<style scoped>
.review-heading p {
    color: #607d8b;
    font-size: 0.92rem;
    margin: 8px 0 0;
}

.review-panel {
    background: linear-gradient(90deg, #ffffff 0%, #fbfdfd 100%) !important;
    border-color: #d8e4e7 !important;
}

.review-panel .row {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
}

.review-detail-row {
    color: #607d8b;
    font-size: 0.92rem;
    margin-top: 8px;
}

.review-label {
    color: #455a64;
    display: inline-block;
    font-size: 0.76rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.review-panel h6 {
    color: #263238;
    font-size: 1.05rem;
    font-weight: 700;
    margin: 0;
}

.review-panel h6 span {
    color: #78909c;
    font-size: 0.88rem;
    font-weight: 700;
}

.review-main-text {
    color: #263238;
    font-weight: 650;
    line-height: 1.4;
}

.review-check {
    color: #00897b;
    font-size: 22px;
}

.review-soft-pill,
.review-setting-pill,
.review-plan-pill,
.review-installment-pill {
    border-radius: 999px;
    display: inline-flex;
    font-size: 0.82rem;
    font-weight: 700;
    line-height: 1.2;
    margin: 4px 6px 0 0;
    padding: 6px 10px;
}

.review-soft-pill {
    background: #eef5f6;
    color: #455a64;
}

.review-setting-pill {
    background: #e0f2f1;
    color: #00695c;
}

.review-plan-pill {
    background: #e8f0fe;
    border: 1px solid #c7d7fb;
    color: #1a4f8b;
}

.summary-action-row {
    align-items: center;
    display: flex;
    gap: 12px;
    justify-content: space-between;
    margin-top: 14px;
}

.summary-action-row .btn-large {
    border-radius: 5px;
    min-width: 138px;
}

.review-installment-pill {
    background: #fff8e1;
    border: 1px solid #ffe082;
    color: #6d4c41;
}

.review-chip-line {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
}

.progress {
    margin-top: -15px;
}

.spacer10 {
    margin-top: 10px;
    margin-bottom: 10px;
}

.pointer {
    cursor: default;
}

.edit-item:hover .material-icons.grey-text,
.edit-item:hover .material-icons.grey-text::before {
    color: rgb(21, 21, 206) !important;
}

/* open */
.chip-more {
    cursor: pointer;
    background-color: #eaecee !important;
}

.chip-more:hover {
    color: white !important;
    background-color: black !important;
}

/* close */
.chip-less {
    cursor: pointer;
    color: white !important;
    background-color: black !important;
}

.chip-less:hover {
    color: black !important;
    background-color: #eaecee !important;
}

/* base class */
.tab-custom {
    display: inline-block;
    cursor: pointer;
    margin: 0 0 -1px;
    padding: 10px 15px;
    font-weight: 600;
    text-align: center;
    border: 1px solid transparent;
}

.tab-custom:hover {
    color: #000000 !important;
}

.tab-custom-active {
    display: inline-block;
    cursor: pointer;
    margin: 0 0 -1px;
    padding: 10px 15px;
    color: white;
    font-weight: 600;
    text-align: center;
    background-color: black;
}

/* display */
.tab-custom-section {
    padding: 20px 0 0;
    border-top: 1px solid #ddd;
}

@media only screen and (max-width: 600px) {
    .review-panel .row {
        display: block;
    }

    .review-label {
        margin-bottom: 8px;
    }

    .review-check {
        margin-top: 10px;
    }

    .summary-action-row {
        align-items: stretch;
        flex-direction: column;
    }
}
</style>
